import React, {FC} from 'react';
import {cleanURL} from '../../helpers';
import {newLabelIcon} from '../../images/svgIcons';
import TranslateMarkdown from '../translation-markdown';
import './styles.scss';

interface CaruselElemProps {
  text: string;
  icon: string;
  title: string;
  type: any;
  dscription: string;
  is_new: boolean;
}

const CaruselElem: FC<CaruselElemProps> = ({text, icon, title, type, dscription, is_new}) => (
  <div id={cleanURL(text)} className={'automation-card-carusel'}>
    <div className="automation-card-header">
      {is_new && <span className="new-label-icon">{newLabelIcon}</span>}
      {title.toLocaleLowerCase().includes('human') && <span className="beta-label-icon">BETA</span>}
      <div className="automation-card-icon">
        <img src={icon} alt={'Tool icon'} />
      </div>

      <div className="fixed-width">
        <h5 className="text-truncate">{title}</h5>
        <h6 className="text-truncate">{type && type.name}</h6>
      </div>
    </div>
    <div className="automation-card-body">
      <p className="text-wrap">
        <TranslateMarkdown
          text={dscription}
        />
      </p>
    </div>
  </div>
);

export default CaruselElem;
